export default {
  namespaced: true,
  state: {
    files: [],
    uploadBtn: null,
    uploader: {
      files: [],
      isUploading: () => {
        return false
      },
      cancel: () => {}
    },
    callbackFiles: [],
    pendingNum: 0,
    isUploading: false
  },
  getters: {
    number(state) {
      return state.files ? state.files.length : 0
    }
  },
  actions: {
    open({ state }) {
      if (state.uploadBtn) {
        state.uploadBtn.click()
      }
    },
    push({ state }, value) {
      state.uploader.addFile(value.file)
      state.callbackFiles.push(value)
    },
    callback({ state }, { file, event, message }) {
      state.callbackFiles.forEach((item) => {
        if (item.file === file.file) {
          // 添加自定义参数
          file.params = item.params
          item[event] &&
            item[event]({ ...file, isThumb: item.isThumb, message })
        }
      })
    },
    async add({ dispatch }, file) {
      let files =
        (await dispatch(
          'admin/db/get',
          {
            dbName: 'database',
            path: 'upload.files',
            defaultValue: [],
            user: true
          },
          { root: true }
        )) || []
      files.push(file)
      dispatch(
        'admin/db/set',
        {
          dbName: 'database',
          path: 'upload.files',
          value: files,
          user: true
        },
        { root: true }
      )
    },
    init({ commit, state }, { uploader, uploadBtn }) {
      uploader.on('catchAll', function(event, file) {
        state.pendingNum =
          uploader.files.filter((t) => !t.isComplete()).length || 0
        state.isUploading =
          uploader.files.filter((t) => t.isUploading()).length > 0
      })
      commit('setUploader', uploader)
      commit('setUploadBtn', uploadBtn)
    },
    cancel({ state }) {
      state.uploader.cancel()
    },
    resume({ state }) {
      const fileList = state.uploader.fileList
      for (var i = fileList.length - 1; i >= 0; i--) {
        fileList[i].resume()
      }
    },
    pause({ state }) {
      const fileList = state.uploader.fileList
      for (var i = fileList.length - 1; i >= 0; i--) {
        fileList[i].pause()
      }
    }
  },
  mutations: {
    setUploader(state, uploader) {
      state.uploader = uploader
      state.files = uploader.files
    },
    setUploadBtn(state, uploadBtn) {
      state.uploadBtn = uploadBtn
    }
  }
}
